import React, { useEffect, useRef, useState } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import _ from 'lodash';

// utils
import chartsUtils, { DataFile } from 'utils/charts.utils';

//chart options
import { barChartoptions } from './barChartHealthOptions';

// styles
import { ChartComboItem } from '../chartCombo/chartCombo';

interface Props {
  dataFiles: DataFile[];
  title: string;
  options?: any;
  localization: ChartComboItem;
  year: number;
  onNoData: () => void;
  onCallback: (chart: React.MutableRefObject<null>) => void;
}

const BarChartHealth = (props: Props) => {
  const chartComponent = useRef(null);
  const [chartOptions, setChartOptions] = useState<any>(_.merge({}, barChartoptions, props.options));

  const getChartSeriesData = () => {
    return [
      {
        showInLegend: false,
        data: [
          getDataForLocationAndYear('Unterste Einkommen (0-25%)', props.dataFiles[0], props.localization.value, props.year),
          getDataForLocationAndYear('Unterer Mittelstand (25-50%)', props.dataFiles[1], props.localization.value, props.year),
          getDataForLocationAndYear('Oberer Mittelstand (50-75%)', props.dataFiles[2], props.localization.value, props.year),
          getDataForLocationAndYear('Oberste Einkommen (75-100%)', props.dataFiles[3], props.localization.value, props.year),
        ],
      },
    ];
  };

  const getDataForLocationAndYear = (name: string, dataFile: DataFile, localizationCode: string, year: number) => {
    const yearData = chartsUtils.getDataForYear(dataFile, year);
    if (!yearData) {
      return null;
    }

    const localizations = chartsUtils.getLocalizationsForData(dataFile);
    if (!localizations) {
      return null;
    }

    const localization = localizations.find((l) => l.code === localizationCode);
    if (!localization) {
      return null;
    }

    const y = yearData[localization.index];

    return {
      name,
      y,
      custom: {
        label: 'UMVERTEILUNG (in CHF pro Kopf)',
      },
    };
  };

  const loadChart = () => {
    const data = getChartSeriesData();
    if (data[0].data.every((d) => d === null)) {
      props.onNoData();
      return;
    }

    setChartOptions((prevOptions: any) => ({
      ...prevOptions,
      tooltip: {
        ...prevOptions.tooltip,
        headerFormat: `<div class="hicharttooltip"><span class="hicharttooltip-title">${props.localization.text}</span>`,
        pointFormatter: function () {
          return `
            <table class="hicharttooltip-table">
              <tr>
                <th>JAHR</th>
                <th style="text-align:right;">${this.custom.label}</th>
              </tr>
              <tr class="hicharttooltip-table-values">
                <td>${props.year}</td>
                <td style="text-align:right;">${Highcharts.numberFormat(this.y, 0)}</td>
              </tr>
            </table>
          `;
        },
      },
      exporting: {
        ...prevOptions.exporting,
        chartOptions: {
          ...prevOptions.exporting.chartOptions,
          title: {
            text: props.title,
          },
        },
      },
      series: data,
    }));
  };

  const handleCallback = (chart: Highcharts.Chart) => {
    props.onCallback(chartComponent);
  };

  useEffect(() => {
    loadChart();
  }, [props.year, props.localization]);

  return (
    <div className="barChartNew">
      <div className="chart-title">{props.title}</div>
      <div className="barChartNew-chart-wrapper">
        <div className="barChartNew-chart">
          <HighchartsReact ref={chartComponent} highcharts={Highcharts} options={chartOptions} callback={handleCallback} />
        </div>
      </div>
    </div>
  );
};

export default BarChartHealth;
